import { Box, BoxProps, ImageProps } from "@chakra-ui/react";
import React from "react";
import Image from "./index";

function OverlayImage({
  overlayColor,
  overlayProps,
  ...props
}: ImageProps & {
  overlayColor?: string;
  overlayProps?: BoxProps;
}) {
  return (
    <Box position="relative" h="full">
      <>{React.createElement(Image, props)}</>
      <Box
        w="full"
        h="full"
        bg={overlayColor || "blackAlpha.600"}
        {...overlayProps}
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          ...overlayProps?.sx,
        }}
      />
    </Box>
  );
}

export default OverlayImage;
